define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi",
	"csi/action/Controller",
	"csi/config",
	"csi/locale"
], function(declare,lang,csi,Controller,config,locale) {

	return declare(Controller, {

		addProxyActions: function(defView, defActions) {
			// summary: if Theme BOM has linked Style BOMs, render Save button as "Delete and Unlink", otherwise "Delete"
			const ctx = this.getContext();
			const bom = ctx.cache.getNode(ctx.getContextNode().__Parent__);
		
			if (bom.$Type != null && bom.$Type === "ApparelBOM" && bom.ThemeBOMLinkedStyleBOMs.length > 0) {
				defActions.addAction(this.getProxyAction("BUTTON_UNLINK_AND_DELETE", true));
			} else {
				defActions.addAction(this.getProxyAction("BUTTON_DELETE", true));
			}
			this.inherited(arguments);
		},

		/**
		 * Show warning message about deleting BOM sections with placements
		 * if Theme BOM has linked Style BOMs, it will display a warning message of unlinking and deleting placements"
		 */
		onCreatePopup: function(view) {
			const ctx = this.getContext();
			const bom = ctx.cache.getNode(ctx.getContextNode().__Parent__);
			var warnMsg = locale.resource("BomSectionMenuDelete_Warning");

			if(bom.$Type != null && bom.$Type === "ApparelBOM" && bom.ThemeBOMLinkedStyleBOMs.length > 0 ){
				 warnMsg = locale.resource("BomSectionMenuDeleteLinked_Warning");
			}

			var placementContainer = this.getParent();
			if (placementContainer.$Type == "ApparelBOMRevision" || placementContainer.$Type == "MaterialBOMRevision") {
				var cache = this.m_cache;
				var bomNode = cache.getNode(placementContainer.__Parent__);
				var lockThemePlacementList = bomNode && config.getNodeSetting(bomNode, "LockThemePlacementList");

				if (lockThemePlacementList) {
					// see if any items are linked to theme
					var blockedSections = {};
					cache.getNodes(placementContainer.Items).forEach(function(item) {
						if (item.FromMaterialPlanPlacement != csi.EMPTY_URL) {
							var secName = (item.DSSection == csi.EMPTY_URL) ? locale.resource(xml.VALUE_BLANK) : cache.getNode(item.DSSection).$Name;
							blockedSections[secName] = true;
						}
					});

					if (Object.keys(blockedSections).length > 0) {
						warnMsg += "  " + locale.resource("BomSectionDelete_LockedSection", [Object.keys(blockedSections).join(",")]);
					}
				}
			}

			view.invalidNode.set("icon", view.invalidNode.WARNING);
			view.invalidNode.set("value", warnMsg);
			this.inherited(arguments);
		}
	});
});